import { EventListeners, MinzeElement } from 'minze'
import { Font } from '../../constants'

export class LvcEventDateCard extends MinzeElement {
  attrs = ['data-is-active', 'data-date-info']

  onSelectDate = (event: Event) => {
    const dateInfoString: string = this.dataDateInfo as string
    const dataDateInfo = JSON.parse(dateInfoString.replace(/'/g, '"'))
    const detail = (event as CustomEvent).detail
    if (!this.shadowRoot) return
    const card = this.shadowRoot.querySelector('.event-date-card')
    if (
      detail?.selectedDateInfo.day === dataDateInfo.day &&
      detail?.selectedDateInfo.month === dataDateInfo.month &&
      detail?.selectedDateInfo.year === dataDateInfo.year
    )
      card?.classList.add('active')
    else card?.classList.remove('active')
  }

  html = () => `
    <div class="event-date-card ${this.dataIsActive ? 'active' : ''}">
      <div class="card-content">
        <div class="card-content-wrapper">
          <div>
            <h4 class="heading_date"><slot name="date"></slot></h4>
            <div class="text_date month"><slot name="month"></slot></div>
            <div class="text_date year"><slot name="year"></slot></div>
          </div>
        </div>
      </div>
    </div>
  `

  css = () => `
    :host {
      font-family: ${Font.family};
    }
    .event-date-card {
      position: relative;
      display: inline-block;
      vertical-align: top;
      width: 100%;
      height: 100%;
      white-space: normal;
      text-align: left;
      cursor: pointer;
    }
    .card-content {
      display: flex;
      width: 75px;
      height: 100%;
      margin-right: 5px;
      margin-bottom: 0px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 1rem;
      opacity: 50%;
      background-color: white;
      border: 1px solid transparent;
      transition: opacity 0.1s ease;
    }
    .active > .card-content {
      opacity: 100%;
    }
    .card-content-wrapper {
      display: flex;
      height: 100%;
      margin-right: 0rem;
      padding: 0.9rem;
      align-items: center;
    }
    .card-content-wrapper > div {
      display: flex;
      height: 100%;
      margin-top: 0rem;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      grid-auto-columns: 1fr;
      grid-column-gap: 0px;
      grid-row-gap: 0px;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto auto;
    }
    .heading_date {
      margin-top: 0;
      margin-bottom: 2px;
      padding-bottom: 0px;
      white-space: normal;
      font-weight: ${Font.weight.extraBold};
      font-size: 22px;
      line-height: 23px;
      color: #1e007d;
    }
    .text_date {
      color: #ff4600;
      font-weight: ${Font.weight.medium};
      font-size: 12px;
      line-height: 12px;
    }
    
    .text_date.month {
      padding-bottom: 0px;
    }
    
    .text_date.year {
      margin-top: 0rem;
    }
  `

  eventListeners: EventListeners = [[window, 'lvc:event-series-date-change', this.onSelectDate]]
}
